import {Product} from '@/model/product';
import {DeliveryMethods} from '@/model/delivery-method';

export class WordpressInputService {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public static getProducts(): Product[] {
    if (process.env.NODE_ENV === 'development') {
      return [
        {
          intention: 'Rasen anlegen/ausbessern',
          product: 'Rasenerde',
          pricePerUnit: 35,
          maxPKWAmount: 2,
          description: 'lorem Ipsum'
        },
        {
          intention: 'Eigenes Gemüse anbauen',
          product: 'Bio Gartenerde',
          pricePerUnit: 64,
          maxPKWAmount: 3,
          description: 'lorem Ipsum'
        },
        {
          intention: 'mein Hochbeet anfüllen',
          product: 'Bio Gartenerde',
          pricePerUnit: 64,
          maxPKWAmount: 3,
          description: 'lorem Ipsum'
        },
        {
          intention: 'Dekor-Rindenmulch aufschütten',
          product: 'Rindemulch',
          pricePerUnit: 40,
          maxPKWAmount: 5,
          description: 'lorem Ipsum'
        }
      ];
    } else {
      // erdinandProducts is a variable derived from tpl_Erdinand_Express.php
      // @ts-ignore
      return erdinandProducts;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public static getDeliveryMethods(): DeliveryMethods {
    if (process.env.NODE_ENV === 'development') {
      return {
        pkw: {
          fillTime: 0.25,
          mapsMultiplicator: 2.4,
          pricePerHour: 60,
          description: 'PKW-Lieferung'
        },
        lkw: {
          fillTime: 0.35,
          mapsMultiplicator: 3.2,
          pricePerHour: 90,
          description: 'LKW-Lieferung'
        }
      }
    } else {
      // erdinandDeliveryMethods is a variable derived from tpl_Erdinand_Express.php
      // @ts-ignore
      const erdinandDeliveryMethodsParsed = JSON.parse(JSON.stringify(erdinandDeliveryMethods));
      const pkw = erdinandDeliveryMethodsParsed[0];
      const lkw = erdinandDeliveryMethodsParsed[1];
      return {
        pkw: {
          fillTime: Number.parseFloat(pkw.fillTime),
          mapsMultiplicator: Number.parseFloat(pkw.mapsMultiplicator),
          pricePerHour: Number.parseFloat(pkw.pricePerHour),
          description: 'PKW-Lieferung'
        },
        lkw: {
          fillTime: Number.parseFloat(lkw.fillTime),
          mapsMultiplicator: Number.parseFloat(lkw.mapsMultiplicator),
          pricePerHour: Number.parseFloat(lkw.pricePerHour),
          description: 'LKW-Lieferung'
        }
      };
    }
  }
}
